import React from "react";
import styles from "./styles.css";
function Loader() {
    return (React.createElement("div", { className: styles.container }, "..."));
}
export default Loader;
